export default "__VITE_ASSET__DQJqlG2F__"